import React, { useEffect, useState } from 'react';
import { Label } from '@abyss/web/ui/Label';
import { Grid } from '@abyss/web/ui/Grid';
import { Link } from '@abyss/web/ui/Link';
import { styled } from '@abyss/web/tools/styled';
import { DateService } from '@src/api/common/DateService';

interface IPageUpdatedSectionProps {
  data: any;
}

const StyledLabel = styled(Label, {
  display: 'inline-block',
  marginLeft: '5px',
  color: '$gray6!important',
});

const PageUpdatedSection: React.FC<IPageUpdatedSectionProps> = ({
  data,
}: IPageUpdatedSectionProps) => {
  const defaultValue: string = 'N/A';
  type DateFieldsType = {
    createdBy: string | null;
    updatedBy: string | null;
    createdDate: string | null;
    updatedDate: string | null;
  };
  const [componentData, setComponentData] = useState<DateFieldsType>({
    createdBy: defaultValue,
    updatedBy: defaultValue,
    createdDate: defaultValue,
    updatedDate: defaultValue,
  });

  useEffect(() => {
    if (data) {
      if (data.createdDate) {
        const created = DateService.ToDateTime(data.createdDate);
        setComponentData((componentData) => ({
          ...componentData,
          createdDate: created,
        }));
      }
      if (data.updatedDate) {
        const updated = DateService.ToDateTime(data.updatedDate);
        setComponentData((componentData) => ({
          ...componentData,
          updatedDate: updated,
        }));
      }
      if (data.createdBy) {
        setComponentData((componentData) => ({
          ...componentData,
          createdBy: data.createdBy,
        }));
      }
      if (data.updatedBy) {
        setComponentData((componentData) => ({
          ...componentData,
          updatedBy: data.updatedBy,
        }));
      }
    }
  }, [data]);

  return (
    <Grid
      css={{
        'abyss-grid': { position: 'absolute', bottom: '25px', right: '20px', display: 'contents' },
      }}
    >
      <Grid.Col
        span={{ xs: 12 }}
        css={{ 'abyss-grid-col': { textAlign: 'end' } }}
      >
        {componentData.createdBy !== defaultValue ? (
          <React.Fragment>
            <StyledLabel size="sm">Created by </StyledLabel>
            <StyledLabel fontWeight="soft" size="sm">
              <Link
                color="$gray6"
                fontWeight="soft"
                size="sm"
                href={`/crm/contact/${componentData.createdBy}`}
                openNewWindow
              >
                {componentData.createdBy}
              </Link>{' '}
              on {componentData.createdDate}
            </StyledLabel>
          </React.Fragment>
        ) : null}
        {componentData.updatedBy !== defaultValue ? (
          <React.Fragment>
            <StyledLabel size="sm">Updated by </StyledLabel>
            <StyledLabel fontWeight="soft" size="sm">
              <Link
                color="$gray6"
                fontWeight="soft"
                size="sm"
                href={`/crm/contact/${componentData.updatedBy}`}
                openNewWindow
              >
                {componentData.updatedBy}
              </Link>{' '}
              on {componentData.updatedDate}
            </StyledLabel>
          </React.Fragment>
        ) : null}
      </Grid.Col>
    </Grid>
  );
};

export { PageUpdatedSection };
